import React from 'react';
import { PartnersTableProps } from './types';
import { styles } from './styles';
import { Table, Column } from '@v2/components';
import { Partner } from '@v2/types';

const columns: Column<Partner>[] = [
  {
    key: 'name',
    header: 'Name',
    sortKey: 'name',
    render: (row) => (
      <div className={styles.nameContainer}>
        <div className={styles.avatar}>
          {row.name?.charAt(0)?.toUpperCase()}
        </div>
        <span className={styles.name}>
          {row.name}
        </span>
      </div>
    ),
  }
];

const PartnersTable: React.FC<PartnersTableProps> = ({
  partners,
  loading,
  error,
  onSelectPartner,
  selectedPartnerId,
  sortConfig,
  onSortChange,
}) => {
  if (error) {
    return (
      <div className={styles.errorContainer}>
        <p className={styles.error}>{error}</p>
      </div>
    );
  }

  return (
    <Table<Partner>
      columns={columns}
      data={partners}
      keyExtractor={(partner) => partner.id}
      loading={loading}
      emptyMessage="No partners found."
      onRowClick={onSelectPartner}
      selectedKeys={selectedPartnerId ? [selectedPartnerId] : []}
      maxHeight="calc(100vh - 200px)"
      sortConfig={sortConfig ?? null}
      onSortChange={onSortChange}
    />
  );
};

export default PartnersTable;
